import { ComponentIds } from "@inter-ikea-core/core";
export class CameraComponent {
    static ID = ComponentIds.CAMERA_COMPONENT_ID;
    typeId = CameraComponent.ID;
    doStoreInSnapshot = true;
    eq(_other) {
        return true;
    }
}
//# sourceMappingURL=CameraComponent.js.map